export const mapRules = (rules: any[]): any => {
  console.log(rules)
  // const mapping = {}
  rules.forEach((rule: any) => {
    switch (rule) {
    case 'required':
    }
  })
}
